<template>
    <div class="d-flex flex-column">
        <!-- <img :src="'/static/images/auth/user-circle.svg'" alt="Click to add a picture" @click.prevent.stop="uploadPhoto" class="avatar pointer" v-if="!newImageBase64"> -->
        <div class="text-center">
            <div class="avatar m-auto">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" alt="Click to add a picture" @click.prevent.stop="uploadPhoto" v-if="!imageToShow">
                    <path style="fill:#8ca0b3;" d="M8 256C8 119.033 119.033 8 256 8s248 111.033 248 248-111.033 248-248 248S8 392.967 8 256zm72.455 125.868C119.657 436.446 183.673 472 256 472s136.343-35.554 175.545-90.132c-3.141-26.99-22.667-49.648-49.538-56.366l-32.374-8.093C323.565 339.79 290.722 352 256 352s-67.565-12.21-93.634-34.591l-32.374 8.093c-26.87 6.718-46.396 29.376-49.537 56.366zM144 208c0 61.856 50.144 112 112 112s112-50.144 112-112S317.856 96 256 96s-112 50.144-112 112z"/>
                </svg>
                <!-- <img :src="imageToShow" v-if="imageToShow" class="avatar pointer radius-circle" @click.prevent.stop="uploadPhoto"> -->
                <div v-if="imageToShow" class="avatarHolder radius-circle" :style="{ 'background-image': 'url(' + imageToShow + ')' }"></div>
            </div>
        </div>
        <div class="text-center">
            <ul class="fs-smallest text-center darker mb-4" v-if="false">
                <li>Minimum dimensions: 300x300px</li>
                <li :class="{'color-6': !isSizeOk}">Max. file size: 1MB</li>
                <li :class="{'color-6': !isFormatOk}">JPG or PNG only</li>
            </ul>

            <button @click.prevent.stop="uploadPhoto" class="btn secondary wide mt-3">Select Picture</button>

            <input type="file" class="hidden" ref="inputAvatarUpload" @change="receiveImage" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value:{
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: 'agent'
            },
            loadThisImage: {
                default: null
            },
            existingImg: {
                default: null,
                type: String
            }
        },
        data: function() {
            return {
                newImageBase64: null,
                sizeLimit:1, // in Mb
                validTypes:[
                    'image/jpeg',
                    'image/png'
                ],
                isSizeOk: true,
                isFormatOk: true,
            }
        },
        created: function () {
            if(this.loadThisImage){
                this.newImageBase64 = this.loadThisImage
            }
        },
        computed: {
            imageToShow: function() {
                if(this.newImageBase64){
                    return this.newImageBase64
                }

                if(this.existingImg){
                    return this.existingImg
                }

                return null

            }
        },
        methods: {
            uploadPhoto: function() {
                this.$refs.inputAvatarUpload.click();
            },
            receiveImage: function(event) {
                let vm = this;
                var reader = new window.FileReader() // if window is not used it says File READER is not defined

                // validate
                this.isFormatOk = this.validateType(event.target.files[0].type, this.validTypes)

                this.isSizeOk = this.validateSize(event.target.files[0].size, this.sizeLimit)

                if(this.isFormatOk && this.isSizeOk){
                    reader.onload = function (event) {

                      // dispatch fileAttached to state UI postEditor with event.target.result as read dataURL
                      let imageDataBase64 = event.target.result
                      vm.newImageBase64 = imageDataBase64;

                      vm.$emit('input', imageDataBase64);
                    }
                    reader.readAsDataURL(event.target.files[0])
                }

                //debug
                //console.log(event.target.files[0]);
            },
            validateType: function(receivedType, validTypesArr) {
                let output = false;
                for (let validType of validTypesArr) {
                    if (receivedType == validType) {
                        output = true;
                    }
                }
                return output
            },
            validateSize: function(givenSize, validSize){
                let sizeInMb = givenSize / (1024*1024);
                return sizeInMb <= validSize
            }
        },
    }
</script>

<style scoped lang="scss">
.avatar{
    width: 100px;
    height: 100px;
}

.avatarHolder{
    width: 100px;
    height: 100px;
    background-position: center;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// AvatarUploader.vue?7d159a32